module.exports = __webpack_public_path__ + "static/img/200248.4e32aed3.png";